











import Vue from 'vue'

export default Vue.extend({
  name: 'ArtistForm',
  data () {
    return {
      artist: ''
    }
  },
  mounted() {
    (this.$refs.input as any).focus()
  },
  methods: {
    clearAllSearchTerms () {
      this.artist = ''
      this.$emit('change', {})
    },
    getMatrixTrackList () {
      this.$emit('change', { searchTerm: this.artist })
    }
  }
})
